/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Convert_AnotherInputs */

const en_tts_tool_convert_another = /** @type {(inputs: Tts_Tool_Convert_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert another text`)
};

const es_tts_tool_convert_another = /** @type {(inputs: Tts_Tool_Convert_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir otro texto`)
};

/**
* | output |
* | --- |
* | "Convert another text" |
*
* @param {Tts_Tool_Convert_AnotherInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_convert_another = /** @type {((inputs?: Tts_Tool_Convert_AnotherInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Convert_AnotherInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_convert_another(inputs)
	return en_tts_tool_convert_another(inputs)
});